/* global Provider */
import React, { Component } from 'react';
import _ from 'underscore';

export default class QuartileChart extends Component {
    constructor(props){
        super(props);

        this.state = {
            selected: {}
        }

		this.client = process.env.REACT_APP_CLIENT
	
    }

    getSelected(){
        return Object.values(this.state.selected);
    }

    addRanking(rank){        
        let newState = Object.assign({}, this.state.selected);
        if (newState[rank.id]){
            delete newState[rank.id];
        }else{
            if (Object.values(newState).length === 20)return;
            newState[rank.id] = rank;
        }
        Provider.setFunds(newState);
		let _selectedTickers = Object.keys(newState).map(cur => {
			return newState[cur].ticker
		})
		Provider.setSelectedPoints(_selectedTickers)
		
        this.setState({ selected: newState})
    }

    render() {
        let qGroups = _.groupBy(Provider.getRankings(), 'quartile');
		let glides = Provider.getGlides();
		
        return (
            <div>
                <div className={"quartile-chart " + (this.props.isPrint ? 'print' : '')}>
                    {Object.keys(qGroups).sort().map((groupKey, index) => {
                        let group = qGroups[groupKey]; //_.sortBy(qGroups[groupKey], 'display');
                        return (
                            <div key={groupKey} className={"group group-" + groupKey}>
                                <label>Quartile {groupKey}</label>
                                <div className="listing">
                                    {group.map((rank, index) => {
                                        if (this.client === 'aci' || (this.client === 'grpaa' && rank.display.indexOf('FlexPath') < 0)) {
											let hasGlide = false
											if (glides[rank.id]) hasGlide = true
											return (
												<div key={rank.id} className={"quartile-item " + (this.state.selected[rank.id] ? 'active': '')} onClick={(event) => {
													if (this.props.isPrint)return;
													this.addRanking(rank);
												}}>
													<label>{rank.display}{!hasGlide && <span></span>}</label>                                        
												</div>
											);
										} else {
											return
										}
                                    })}
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className="arrows">
                    <span>&nbsp;</span>
                    <div>More Suitable</div>
                    <div>Less Suitable</div>
                </div>
            </div>
        );
    }    
}